import styled from "styled-components";
import { Box } from "@viagogo/core/ui";

export const Container = styled(Box)<{ isPhone?: boolean; reducedTopMargin?: boolean }>`
  border: 1px solid #fae7b7;
  background-color: ${(props) => props.theme.colors.backgroundWarning};
  border-radius: 10px;
  padding: ${(props) => (props.isPhone ? "32px 20px" : "50px")};
  margin-top: ${(props) =>
    props.isPhone ? `${props.reducedTopMargin ? "5" : "30"}px` : `${props.reducedTopMargin ? "20" : "40"}px`};
  margin-bottom: ${(props) => (props.isPhone ? "0px" : "50px")};
`;

export const ListItem = styled.li`
  margin-top: ${(props) => props.theme.spacing(1)};
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.body1)};
`;

export const ListWrapper = styled.ul`
  padding-left: ${(props) => props.theme.spacing(5)};
  list-style: auto;
`;

export const Message = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.subtitle1, fontWeight.bold)};
  color: ${(props) => props.theme.colors.textStrong};
`;

export const Title = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title5)};
  color: ${(props) => props.theme.colors.textStrong};
  padding-bottom: ${(props) => props.theme.spacing(5)};
`;
